import gql from "graphql-tag";

export const downloadFormatsQuery = gql`
  query downloadFormats {
    downloadFormats {
      url
      status
    }
  }
`;
